<template>
  <div>
    <div class="card-project">
      <div class="card-project__header card-project__header--between">
        <div
          class="card-project__header-info card-project__header-info--settings">
          <div class="card-project__avatar">
            <font-awesome-icon :icon="dataIconUser" />
          </div>
          <div class="card-project__title">
            {{ dataUserObj.name }}
          </div>
        </div>
        <div>
          <call-button
            type="danger"
            :icon="dataIconLock"
            plain
            @click="$root.$emit('logout')">
            Logout
          </call-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CallButton from '../../components/common/CallButton';
import { USER_INFO } from '../../store/types/actions.types';
import { faSignOutAlt, faUser, faPen } from '@fortawesome/pro-regular-svg-icons';
import projectTable from '../../mixins/table/projectTable';
import { mapGetters } from 'vuex';

export default {
  name: 'PageSettings',
  components: { CallButton },
  mixins: [projectTable],
  data () {
    return {
      dataIconLock: faSignOutAlt,
      dataIconUser: faUser,
      dataIconPen: faPen,
      dataUserObj: {},
      dataShowProjectSetting: false
    };
  },

  computed: {
    ...mapGetters({
      computedIsAdmin: 'auth/isAdmin',
      computedIsModerator: 'auth/isModerator',
      computedIsOperator: 'auth/isOperator'
    })
  },
  async created () {
    this.$store.dispatch('loading/startLoading');
    try {
      const { user = {} } = await this.$store.dispatch(`user/${USER_INFO}`);
      this.dataUserObj = user;
    } catch (e) {
      throw Error(e);
    } finally {
      this.$store.dispatch('loading/stopLoading');
    }
  },

  methods: {}
};
</script>
